import axios from '@/http.js';

export default {
  getGroupList (params) {
    const url = '/api/material/psdGroup/query';
    return axios.post(url, params, {
      headers: {
        projectId: params.projectId
      }
    });
  },
  deleteGroups (ids, projectId) {
    const url = '/api/material/psdGroup/delete';
    return axios.delete(url, {
      data: ids, headers: {
        projectId: projectId
      }
    });
  },
  addGroup (data, projectId, templateId) { // 删除所有，再插入
    const url = '/api/material/psdGroup/save';
    return axios.post(url, data, {
      headers: {
        templateId: templateId,
        projectId: projectId
      }
    })
  },
  updateGroup (data) {
    const url = '/api/material/psdGroup/update';
    return axios.put(url, data, {
      headers: {
        projectId: data.projectId
      }
    })
  }
}